module.exports = __webpack_public_path__ + "static/media/3-march-news-mobile.20f9f08f.png";